<template>
  <nav>  
    <v-toolbar fixed app floating>
      <v-toolbar-title> <span class="font-weight-bold green--text darken-2"> PROPERSAM</span> </v-toolbar-title>
    </v-toolbar>
  </nav>
</template>

<script>
  export default {
      data: () => ({
        // drawer: false
      }),
  }
</script>

